import { Grid } from '@mui/material';
import type { GridSize } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttFormDate } from './SttFormDate';
import { SttFormCheck } from '../all';

type SttFormPeriodProps = {
    grid?: boolean;
    caption?: string;
    captionIni?: string;
    captionEnd?: string;
    checked?: boolean;
    onToggle?: (value: boolean) => void;
    onChange?: ({
        name,
        value,
    }: {
        name: string | undefined;
        value: unknown;
    }) => void;
    nameIni: string;
    nameEnd: string;
    defValIni?: string;
    defValEnd?: string;
    disabled?: boolean;
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
    lg?: GridSize;
    xl?: GridSize;
};

export function SttFormPeriod({
    grid = false,
    caption,
    captionIni,
    captionEnd,
    checked,
    onToggle,
    onChange,
    nameIni,
    nameEnd,
    defValIni,
    defValEnd,
    disabled,
    xs = 12,
    sm,
    md,
    lg,
    xl,
}: SttFormPeriodProps) {
    const { t } = useTranslation();
    const checkingEnabled = checked !== undefined;

    const content = (
        <>
            {checkingEnabled && (
                <SttFormCheck
                    name="check"
                    caption={caption}
                    checked={checked}
                    onChange={({ value }: any) => onToggle?.(value)}
                />
            )}

            <Grid container spacing={3}>
                <SttFormDate
                    grid
                    xs={12}
                    sm={6}
                    caption={
                        !checkingEnabled
                            ? captionIni || t('PeriodFrom')
                            : undefined
                    }
                    name={nameIni}
                    defVal={defValIni}
                    onChange={onChange}
                    disabled={(checkingEnabled && !checked) || disabled}
                />

                <SttFormDate
                    grid
                    xs={12}
                    sm={6}
                    caption={
                        !checkingEnabled ? captionEnd || t('Until') : undefined
                    }
                    name={nameEnd}
                    defVal={defValEnd}
                    onChange={onChange}
                    disabled={(checkingEnabled && !checked) || disabled}
                />
            </Grid>
        </>
    );

    return grid ? (
        <Grid size={{ xs, sm, md, lg, xl }}>{content}</Grid>
    ) : (
        content
    );
}
